/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultIconAsset } from '../../models/api-response-paged-result-icon-asset';
import { PagedRequestIconAssetSearchReq } from '../../models/paged-request-icon-asset-search-req';

export interface GetListIconAsset$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestIconAssetSearchReq
}

export function getListIconAsset(http: HttpClient, rootUrl: string, params: GetListIconAsset$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultIconAsset>> {
  const rb = new RequestBuilder(rootUrl, getListIconAsset.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultIconAsset>;
    })
  );
}

getListIconAsset.PATH = '/v1/api/admin-ui/icon-asset/list';
